import './phone-script-redirection-workspace.ajscss';

import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { ScriptAnchor } from '@agent/core/phone/script-redirection/models/script-anchor';
import { IScriptRedirect } from '@agent/core/phone/script-redirection/models/script-redirection';
import { IScriptRedirectionService } from '@agent/core/phone/script-redirection/script-redirection.service';
import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import { IComponentController, IComponentOptions, ILogService, isDefined } from 'angular';

import { EntryPointType } from '@contact/upgrade';

import templateUrl from './phone-script-redirection-workspace.template.html';

export class PhoneScriptRedirectionWorkspaceCtrl implements IComponentController {
  responseId: string;
  availableAnchorsForCsrPark: ScriptAnchor[] = [];
  availableAnchorsForCsrRelease: ScriptAnchor[] = [];
  scriptRedirect: IScriptRedirect;
  displayAnchorsForCsrRelease: boolean = false;
  displayAnchorsForCsrPark: boolean = false;
  displayChoices: boolean = false;

  constructor(
    protected readonly $log: ILogService,
    protected readonly contactDeprecatedService: IContactDeprecatedService,
    protected readonly sessionDeprecatedService: SessionDeprecatedService,
    protected readonly scriptRedirectionService: IScriptRedirectionService
  ) {}

  get isScriptRedirecting(): boolean {
    return this.scriptRedirectionService.isRedirectInProgress(this.responseId);
  }

  $onInit(): void {
    this.$log.debug('anchor workspace init');
    this.scriptRedirect = this.scriptRedirectionService
      .getScriptRedirect(this.responseId)
      .getOrElseFunc(() => this.scriptRedirectionService.createScriptRedirect(this.responseId));
    this.scriptRedirectionService.getScriptAnchors(this.responseId).then(anchors => {
      anchors.forEach(anchor => {
        if (anchor.type === EntryPointType.PARK_CSR) {
          this.availableAnchorsForCsrPark.push(anchor);
        } else if (anchor.type === EntryPointType.RELEASE_CSR) {
          this.availableAnchorsForCsrRelease.push(anchor);
        }
      });

      if (this.availableAnchorsForCsrPark.length > 0 && this.availableAnchorsForCsrRelease.length === 0) {
        this.scriptRedirect.type = EntryPointType.PARK_CSR;
        this.updateScriptRedirect();
      }

      this.displayAnchorsForCsrRelease =
        (this.sessionDeprecatedService.hasPermission('CSR_PHONE_INCOMING::contact:redirect_to_script_anchor_with_csr_release') ||
          this.sessionDeprecatedService.hasPermission('CSR_PHONE_OUTGOING::contact:redirect_to_script_anchor_with_csr_release') ||
          this.sessionDeprecatedService.hasPermission('CSR_UNITARY_PHONE_OUTGOING::contact:redirect_to_script_anchor_with_csr_release')) &&
        this.availableAnchorsForCsrRelease.length > 0;
      this.displayAnchorsForCsrPark =
        (this.sessionDeprecatedService.hasPermission('CSR_PHONE_INCOMING::contact:redirect_to_script_anchor_with_csr_park') ||
          this.sessionDeprecatedService.hasPermission('CSR_PHONE_OUTGOING::contact:redirect_to_script_anchor_with_csr_park') ||
          this.sessionDeprecatedService.hasPermission('CSR_UNITARY_PHONE_OUTGOING::contact:redirect_to_script_anchor_with_csr_park')) &&
        this.availableAnchorsForCsrPark.length > 0;
      this.displayChoices = this.displayAnchorsForCsrRelease && this.displayAnchorsForCsrPark;
    });
  }

  $onDestroy(): void {
    this.$log.debug('anchor workspace destroy');
    this.scriptRedirectionService.removeScriptRedirect(this.responseId);
  }

  updateScriptRedirect(): void {
    this.scriptRedirectionService.updateScriptRedirect(this.responseId, this.scriptRedirect);
  }

  anchorLabel(anchor: ScriptAnchor): string {
    if (isDefined(anchor.alias) && anchor.alias !== '') {
      return anchor.alias;
    }
    return anchor.name;
  }

  getCsrReleaseType(): EntryPointType {
    return EntryPointType.RELEASE_CSR;
  }

  getCsrParkType(): EntryPointType {
    return EntryPointType.PARK_CSR;
  }
}

export class PhoneScriptRedirectionWorkspace implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = ['$log', 'contactDeprecatedService', 'sessionDeprecatedService', 'scriptRedirection', PhoneScriptRedirectionWorkspaceCtrl];
}

export default 'contactPhoneScriptRedirectionWorkspace';
